class LocalStorage {
  set(key, value, expire) {
    let data;
    if (expire !== undefined) {
      data = {
        expire,
        value,
      };
    } else {
      data = value;
    }
    localStorage.setItem(key, JSON.stringify(data));
  }

  get(key) {
    let s = localStorage[key];
    if (s === undefined) {
      return undefined;
    }
    s = JSON.parse(s);
    if (!s.expire) {
      return s.value ? s.value : s;
    }
    if (new Date(s.expire) > new Date()) {
      return s.value;
    }
    localStorage.removeItem(key);
    return undefined;
  }
}
export default new LocalStorage();
